module.exports = __webpack_public_path__ + "img/icon-upload-file.4ea765af.svg";